// supabase-js wraps non-2xx Edge Function responses in a FunctionsHttpError whose
// .context is the raw Response. Our functions reply with { error: '<reason>' }, so
// pull that out for a specific message; fall back to the generic text otherwise.
export async function extractFunctionError(error, fallback = 'Something went wrong. Please try again.') {
  try {
    const res = error?.context
    if (res && typeof res.json === 'function') {
      const body = await res.json()
      if (body?.error && typeof body.error === 'string') return body.error
    }
  } catch {
    /* body not JSON / already consumed — fall through */
  }
  return error?.message || fallback
}
